import React from 'react';

import {
  InvoiceAvInvoiceBillingInfoContactEmail,
  InvoiceID,
  InvoiceUpdateAvInvoiceBillingInfoContactEmailCacheKeys
} from '../../../invoicesTypes';
import { IconsEnum } from '../../../../../assets/icons/types';
import { ClassName, I18nText, IsDisabled } from '../../../../../types';

import { useInvoiceUpdateAvInvoiceBillingInfoContactEmailForm } from './hooks/useInvoiceUpdateAvInvoiceBillingInfoContactEmailForm';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { Form } from '../../../../../helpers/Form';
import { FormModalButton } from '../../../../../helpers/buttons/FormModalButton';
import { InputField } from '../../../../../helpers/FormFields/InputField';

import { formsFields, teamsKeys, words } from '../../../../../locales/keys';

interface InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButtonProps {
  invoiceId: InvoiceID;
  contactEmail: InvoiceAvInvoiceBillingInfoContactEmail;
  cacheKeys?: InvoiceUpdateAvInvoiceBillingInfoContactEmailCacheKeys;
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  tooltipI18nText?: I18nText;
  disabled?: IsDisabled;
}

const INVOICE_UPDATE_AV_INVOICE_BILLING_INFO_CONTACT_EMAIL_FORM =
  'invoice-update-av-invoice-billing-info-contact-email-form';

function InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButton({
  invoiceId,
  contactEmail,
  cacheKeys,
  className,
  i18nText,
  icon,
  iconClassName,
  tooltipI18nText,
  disabled
}: InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButtonProps) {
  const {
    updateInvoiceContactEmailErrorMessage,
    updateInvoiceContactEmailLoading,
    emailRegister,
    handleUpdateInvoiceContactEmail,
    resetForm,
    updateInvoiceContactEmailReset,
    validationErrors
  } = useInvoiceUpdateAvInvoiceBillingInfoContactEmailForm({
    invoiceId,
    contactEmail,
    cacheKeys
  });

  return (
    <FormModalButton
      className={className}
      form={INVOICE_UPDATE_AV_INVOICE_BILLING_INFO_CONTACT_EMAIL_FORM}
      i18nSubmitText={words.saveChanges}
      i18nText={i18nText}
      i18nTitle={teamsKeys.changeEmail}
      icon={icon}
      iconClassName={iconClassName}
      tooltipI18nText={tooltipI18nText}
      isLoading={updateInvoiceContactEmailLoading}
      onOpen={resetForm}
      onClose={updateInvoiceContactEmailReset}
      onSubmit={handleUpdateInvoiceContactEmail}
      submitDisabled={updateInvoiceContactEmailLoading}
      disabled={disabled}
    >
      <div className="flex-1 overflow-y-auto px-2">
        <div className="p-4">
          <Form id={INVOICE_UPDATE_AV_INVOICE_BILLING_INFO_CONTACT_EMAIL_FORM}>
            <InputField
              inputWrapperClassName="relative mt-1"
              labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
              i18nLabel={formsFields.contactEmail}
              ref={emailRegister.ref}
              name={emailRegister.name}
              onChange={emailRegister.onChange}
              disabled={updateInvoiceContactEmailLoading}
              error={validationErrors}
              autoComplete="off"
              type="text"
            />
          </Form>
        </div>
      </div>
      <div className="px-4">
        <AlertMessage message={updateInvoiceContactEmailErrorMessage} />
      </div>
    </FormModalButton>
  );
}

export default InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButton;
